import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { PhotoUploaderStyles } from "./PhotoUploaderStyles";

const downloadOswaldFont = () => {
  const style = document.createElement("style");
  style.innerHTML = `
    @import url('https://fonts.googleapis.com/css2?family=Oswald&display=swap');
  `;
  document.head.appendChild(style);
};

const descriptionForCCCPhotoUpload = (
  <Grid item xs={12}>
    <p className="selectPhotoDesc" style={{ marginTop: "0rem" }}>
      {"Please select one photo to add to each section. If you have additional " +
        "photos you can add them at the"}{" "}
      {"end. Only upload .jpg files that are 10MB or less."}
    </p>
  </Grid>
);

const descriptionForNuxeoPhotoUpload = (
  <Grid item xs={12}>
    <p className="selectPhotoDesc" style={{ marginTop: "0rem" }}>
      {
        "Please select the additional photos that you would like to upload. Only upload .jpg files that are 10MB or less."
      }
    </p>
  </Grid>
);

function SelectPhoto({ isCCC }) {
  const classes = PhotoUploaderStyles();

  useEffect(() => {
    downloadOswaldFont();
  }, []);

  return (
    <Grid container>
      <Grid item xs={12}>
        <p className={classes.selectPhoto} style={{ marginTop: "1rem" }}>
          Select your photos.
        </p>
      </Grid>
      {isCCC ? descriptionForCCCPhotoUpload : descriptionForNuxeoPhotoUpload}
    </Grid>
  );
}

SelectPhoto.propTypes = {
  isCCC: PropTypes.bool.isRequired,
};

/* eslint-enable no-alert */

export default SelectPhoto;
